/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Addresses/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Address from './Address/index'
import Heading from './Heading/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Addresses({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/Patient/Addresses"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let editRelationAddressesValueData = fromData.useDataValue({ viewPath,
context: 'edit_relation',
path: 'addresses',
})
  return (<React.Fragment
>
<div
  data-testid="Addresses.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-Z1FipdA': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-2-Z1FipdA': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Heading
  viewPath={`${viewPath}/Heading`}
/>
<div
  data-testid="Addresses.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(editRelationAddressesValueData) && editRelationAddressesValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="edit_relation_address"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Address(${item?.id ?? item?._id ?? index})`}
      >
<Address
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Address(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }